<template>
  <pull-to class="eds-privacy">
    <div class="privacy">{{ privacy }}</div>
  </pull-to>
</template>

<script>
import { URLS } from '../util/urls'
import axios from 'axios'
import msgbus from '../msgBus'
import PullTo from 'vue-pull-to'
import i18n from '../lang/index'


export default {
  name: 'eDS-privacy',
  components: {
    PullTo,
  },
  data() {
    return {
      privacy: '', // 隐私政策
    }
  },
  methods: {
    // 获取协议
    getPrivacy() {
      axios({
        method: 'get',
        url: URLS.EDS_PRIVACY_URL,
        params: {
          language: i18n.locale,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
      }).then((res) => {
        this.privacy = res.data.content
      })
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitleList({
        visible: false,
        list: [],
        listIcon: [],
        change: () => { },
        curValue: '',
        curIcon: '',
      })
      msgbus.vm.setTitle(this.$t('隐私政策'))
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px ` + ')',
      })
      msgbus.vm.setMenuDisabled(true)
    },
  },
  created() {
    console.log('调试代码')
    // 获取协议
    this.getPrivacy()

    // 切换界面样式
    this.changeView()
  },
  mounted() { },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
    msgbus.vm.setBottomBtnVisible(false)
  },
}
</script>

<style lang="scss">
.eds-privacy {
  height: 100%;

  .privacy {
    white-space: pre-wrap;
    text-align: left;
    margin-left: 20px;
    margin-right: 20px;
  }
}
</style>
